export default "__VITE_ASSET__TuC7Vdh4__"